import axios from 'axios';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import messageConfig from '@/helpers/message.config';
import {
	requestGrowthplateLogout,
	requestGrowthplateRightNowLogout,
	duplicatedToken,
	logout,
	moveGrowthplateLogin,
	logoutMacadamia,
} from '@/helpers/common';

const LOGIN = '/login';
const EVAL_LOGIN = '/eval-login';

let isRefreshing = false;
let failedQueue = [];
// const isLog = false;
const isLog = true;

const processQueue = (error, token = null) => {
	failedQueue.forEach(prom => {
		error ? prom.reject(error) : prom.resolve(token);
	});
	failedQueue = [];
};
const service = axios.create({
	// withCredentials: true,
	// timeout: 1000 * 60 * 30 // TimeOut 30분으로 설정
	// baseURL: 'https://d-krt-api.daekyo.com',
	timeout: 1000 * 30, // TimeOut 30초으로 설정
	baseURL: process.env.VUE_APP_API_URL,
});

service.interceptors.request.use(
	config => {
		// 헤더 토큰을 발급받은 토큰으로 설정
		const gStore = GlobalStore();
		const token = gStore.token;
		// const token = "abceyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxMjYwIiwiYXVkIjoiZGFla3lvIGZyb250ZW5kIiwicm9sZSI6IlJPTEVfU1RVREVOVCIsImlzcyI6ImtydC5kYWVreW8uY29tIiwiZXhwIjoxNjg2MjQzNjE1fQ.BaXCJNtvxRV6v9toRv5U-fcebT2F5odAAN08qvVQvwJooLK5MXYpeTAVL0xWExlQCsBGg7bqSGwxvWTXiXC9q7npTnqJgYRFBasZQlxO-DSZWnXa8qJpoto6aR_M62-Qfp7xGcLhS6Oo4dEJGg-bDE4nWpKfJDxcNs8wBqfQ7YM_XubogMMML8YaMiZYHP-mGZW3WZ53NKGfl7Dz-22dPCKD8IfDMqR0NSZwas2Yh8AoYNbx3_eVO5VyIdLnmyGtS5tdvCwJT40R8lhez8HK4lQVNjHZLFRq8np_FW-Dt7iJo1TYdfQyjsYKAv9BctSazIZAf0zBTuyZSsIT1DQFRw"
		config.headers.Authorization = `Bearer ` + token;
		// config.headers['Access-Control-Allow-Origin'] = '*';
		return config;
	},
	error => {
		if (isLog) console.error('--Service_APP-request ERR:', error?.request);
		return Promise.reject(error);
	}
);
/**
 * Response interceptor
 */
service.interceptors.response.use(
	response => {
		// todo: 공통 예외처리 필요할시 처리
		if (isLog) console.log('-Service_APP-response:', response);
		return response;
	},
	async error => {
		if (isLog)
			console.log(
				'----------Service_APP-error11 start error?.response:',
				error.response
			);
		const gStore = GlobalStore();
		const dStore = DialogStore();
		const isMemberEval =
			gStore.is_member_eval === undefined || gStore.is_member_eval;
		const statusCode = error?.response?.data?.statusCode;
		const statusMsg = error?.response?.data?.message;
		const loginRoot = gStore.loginRoot === undefined || gStore.loginRoot;
		console.log('statusCode ===', statusCode);
		console.log('statusCode ===', statusCode);
		console.log('statusCode ===', statusCode);
		console.log('statusCode ===', statusCode);
		console.log('statusCode ===', statusCode);
		switch (statusCode) {
			case 'G407': // 로그인실패
			case 'G408': // 이미진단평가완료
			case 'G409': //배치로 생성된게 아닌 체험계정
				dStore.openMsg(messageConfig[statusCode] || statusMsg, val => {
					requestGrowthplateRightNowLogout();
				});
				return error.response;
			case '806': // 로그인실패
			case '847': // 이미진단평가완료
			case '853': // 휴면 상태 계정
			case '854': // 학습중단 상태 계정
			case '857': // 학원코드 비유효(진단평가)
			case '861': // 퇴회 처리 계정
			case '868': // 비번불일치
				dStore.openMsg(messageConfig[statusCode] || statusMsg, () => {
					if (loginRoot == 'external-login') {
						window.location.href = '/krt-login';
					} else if (loginRoot == 'web') {
						window.location.href = '/exp-login';
					}
				});
				return error.response;
			case '809': // 유효하지 않은 토큰
			case '801': // 유효하지 않은 요청
			case '867': // 중복로그인
				dStore.openMsg(messageConfig[statusCode] || statusMsg, val => {
					/*
					 * KRT-2045 이슈로 인해 변경.
					 * as : 성장판 - 메인화면으로 이동, 마카다미아 - 그냥 로그인 페이지 호출
					 * to : 성장판 - 중복 로그인 처리로 login 페이지 이동, 마카다미아 - sso 로그아웃 호출
					 */
					duplicatedToken();
				});
				return error.response;
			case '820': //  현재 진행중인 학습정보가 존재하지 않습니다
			case '822': //  dailyreport 학습이력을 찾을수 없습니다
			case '828': //  추천학습 이력을 찾을수 없습니다
			case '829': //  리셋학습 이력을 찾을수 없습니다
			case '830': //  시험지 정보를 찾을 수 없습니다
			case '833': //  잘못된 Q-Bank 문항코드 입니다
			case '834': //  잘못된 시험지 형식 입니다
			case '835': //  Q-Bank 동기화 정보가 존재하지 않습니다
			case '836': //  지원하지 않는 동작입니다
			case '837': //  출시된 시험지 버전정보가 존재하지 않습니다
			case '838': //  해당영역에 대한 학습이력이 존재하지 않습니다
			case '839': //  유효하지 않은 학습이력 정보 입니다
			case '841': //  진단평가정보x
			case '842': //  레벨 정보를 찾을 수 없습니다
			case '843': //  레슨 정보를 찾을 수 없습니다
			case '850': //  학생 알림 정보가 존재하지 않습니다
			case '852': //  학습정보가 존재하지 않습니다
			case '856': //  코너와 맞지 않는 시험지 명입니다
			case '905': //  요청한 URL을 찾을 수 없습니다.
			case '908': //  읽을 수 있는 요청 정보가 없습니다.
				dStore.openMsg(messageConfig[statusCode] || statusMsg, val => {
					window.location.href = '/learninghome';
				});
				return error.response;
			default: {
				const originalRequest = error?.config;
				// 토큰만료 error check
				if (error?.response?.status === 401 && !originalRequest._retry) {
					const gtoken = gStore.token;
					const rtoken = gStore.retoken;
					if (isRefreshing) {
						return new Promise(function refFunc(resolve, reject) {
							failedQueue.push({ resolve, reject });
						})
							.then(token => {
								originalRequest.headers.Authorization = `Bearer ` + token;
								return axios(originalRequest);
							})
							.catch(err => {
								// return Promise.reject(err);
								return err.response;
							});
					}
					originalRequest._retry = true;
					isRefreshing = true;

					return axios
						.post(
							process.env.VUE_APP_API_URL + `/api/user/refresh`,
							{ token: rtoken },
							{ headers: { Authorization: `Bearer ` + rtoken } }
						)
						.then(response => {
							if (
								response?.data?.message &&
								response?.data?.message.indexOf('성공') > -1
							) {
								const returnData = response.data.data;
								// 토큰 쿠키 저장
								if (isLog)
									console.log('-- @@@@Service_APP requsetRetoken@@@@ -- ');
								gStore.setToken(returnData?.accessToken);
								gStore.setReToken(returnData?.refreshToken);
								// 헤더 토큰을 새로 발급받은 토큰으로 재설정
								service.defaults.headers.common.Authorization =
									`Bearer ` + returnData?.accessToken;
								processQueue(null, returnData?.accessToken);
								// 반환
								return service(originalRequest);
							}
							processQueue(error, null);
							if (
								gStore.loginRoot === 'web' ||
								gStore.loginRoot === 'external-login'
							) {
								//토큰정보 삭제
								gStore.initStore();
							}
							if (gStore.loginRoot === 'growthplate') {
								requestGrowthplateLogout();
							} else if (loginRoot === 'macadamia') {
								logoutMacadamia();
							} else if (loginRoot == 'web') {
								window.location.href = '/exp-login';
							} else {
								window.location.href = '/krt-login';
							}
						})
						.catch(error => {
							if (isLog)
								console.log('@@@@Service_APP catch   statusCode:', statusCode);
							processQueue(error, null);
							gStore.initToken();
							if (statusCode === '810') {
								dStore.openMsg(messageConfig[statusCode] || statusMsg, val => {
									if (
										gStore.loginRoot === 'web' ||
										gStore.loginRoot === 'external-login'
									) {
										//토큰정보 삭제
										gStore.initStore();
									}
									if (gStore.loginRoot === 'growthplate') {
										requestGrowthplateLogout();
									} else if (loginRoot === 'macadamia') {
										logoutMacadamia();
									} else if (loginRoot == 'web') {
										window.location.href = '/exp-login';
									} else {
										window.location.href = '/krt-login';
									}
								});
							} else {
								if (
									gStore.loginRoot === 'web' ||
									gStore.loginRoot === 'external-login'
								) {
									//토큰정보 삭제
									gStore.initStore();
								}
								if (gStore.loginRoot === 'growthplate') {
									requestGrowthplateLogout();
								} else if (loginRoot === 'macadamia') {
									logoutMacadamia();
								} else if (loginRoot == 'web') {
									window.location.href = '/exp-login';
								} else {
									window.location.href = '/krt-login';
								}
							}
							return error.response;
						})
						.finally(() => {
							if (isLog) console.log('@@@@Service_APP final');
							isRefreshing = false;
						});
				} else {
					if (statusCode) {
						// 그 외 401아닌 모든 statusCode : ex) 801 유효하지 않은 ,'867': 중복로그인
						if (isLog)
							console.error('@@@@Service_APP : statusCode', statusCode);
						if (
							gStore.loginRoot === 'web' ||
							gStore.loginRoot === 'external-login'
						) {
							//토큰정보 삭제
							gStore.initStore();
						}
						if (gStore.loginRoot === 'growthplate') {
							requestGrowthplateLogout();
						} else if (loginRoot === 'macadamia') {
							logoutMacadamia();
						} else if (loginRoot == 'web') {
							window.location.href = '/exp-login';
						} else {
							window.location.href = '/krt-login';
						}

						// dStore.openMsg(messageConfig[statusCode] || statusMsg, (val) => { window.location.href = gStore.is_member_eval ? '/login' : '/eval-login'; });
					} else {
						if (isLog)
							console.log('@@@@Service_APP 서버 장애:', error?.response);
						gStore.initToken();
						dStore.errorConnection(val => {
							if (val && gStore.loginRoot === 'growthplate') {
								moveGrowthplateLogin(); //로그인 창으로 보내는 브릿지 함수가 이것밖에 없음..
								// moveGrowthplateHome();
								//requestGrowthplateLogout();
								//requestGrowthplateRightNowLogout();
							} else if (loginRoot === 'macadamia') {
								window.location.href = process.env.VUE_APP_SSO_LOGIN_URL;
							} else if (loginRoot == 'web') {
								window.location.href = '/exp-login';
							} else {
								window.location.href = '/krt-login';
								//window.location.href = isMemberEval ? process.env.VUE_APP_SSO_LOGIN_URL : EVAL_LOGIN;
							}
						});
					}
					// 4xx 클라이언트 오류가 아닌 5xx 서버 오류
					if (error.response) return error.response;
					else return Object.assign(error, { data: {} });
				}
			}
		}
	}
);
/** *    */
export async function exchangeRefreshToken() {
	const gStore = GlobalStore();
	const dStore = DialogStore();
	const rtoken = gStore.retoken;
	const isMemberEval =
		gStore.is_member_eval === undefined || gStore.is_member_eval;
	// if (isLog) console.log('@@@@Service_APP exchangeRefreshToken rtoken:', rtoken);
	if (!rtoken) return; // 비회원 진단평가는 rToken없음.
	const res = await doRefreshToken(rtoken);
	if (res) {
		if (res?.data?.message && res?.data?.message.indexOf('성공') > -1) {
			const returnData = res.data.data;
			// 토큰 쿠키 저장
			if (isLog) console.log('@@@@Service_APP OK res:', res);
			gStore.setToken(returnData?.accessToken);
			gStore.setReToken(returnData?.refreshToken);
			// if (isLog) console.log('@@@@Service_APP exchangeRefreshToken gStore.accessToken:', gStore.token);
			// if (isLog) console.log('@@@@Service_APP exchangeRefreshToken gStore.retoken:', gStore.retoken);
			// 헤더 토큰을 새로 발급받은 토큰으로 재설정
			service.defaults.headers.common.Authorization =
				`Bearer ` + returnData?.accessToken;
			processQueue(null, returnData?.accessToken);
		}
	} else {
		if (isLog) console.error('@@@@Service_APP catch123:', error?.response);
		if (isLog)
			console.error(
				'@@@@Service_APP catch  error?.response.data.statusCode:',
				error?.response.data.statusCode
			);
		processQueue(error, null);
		// gStore.initToken();
		if (error?.response.data.statusCode === '810') {
			dStore.openMsg(
				`장시간 활동이 없어 자동으로<br/> 로그아웃 되었습니다.`,
				val => {
					logout();
					// if (gStore.loginRoot === 'growthplate') {
					//     requestGrowthplateLogout();
					// } else {
					//     window.location.href = isMemberEval ? process.env.VUE_APP_SSO_LOGIN_URL : EVAL_LOGIN;
					// }
				}
			);
		} else {
			logout();
			// if (gStore.loginRoot === 'growthplate') {
			//     requestGrowthplateLogout();
			// } else {
			//     window.location.href = isMemberEval ? process.env.VUE_APP_SSO_LOGIN_URL : EVAL_LOGIN;
			// }
		}
	}
	return res;
}

/** *    */
export async function doRefreshToken(rtoken) {
	const gStore = GlobalStore();
	try {
		gStore.setIsRefreshingToken(true);
		const res = await service({
			url: '/api/user/refresh',
			method: 'post',
			data: { token: rtoken },
			headers: { Authorization: `Bearer ${rtoken}` },
		});
		gStore.setIsRefreshingToken(false);
		return res;
	} catch (e) {
		gStore.setIsRefreshingToken(false);
		return e?.response;
	}
}

export default service;
